import React from 'react';
import styled from '@emotion/styled';

interface SkeletonBlockProps {
  width: string;
  height: string;
  circle?: boolean;
}

const SkeletonBlock = styled.div<SkeletonBlockProps>`
  background-color: ${({ theme }) => theme.palette.greyGrey4};
  border-radius: ${(props) => (props.circle ? '50%' : '4px')};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;

const LocumProfileSkeleton: React.FC = () => (
  <SkeletonContainer>
    {/* Bio section */}
    <BioHeader>
      <SkeletonBlock width="70px" height="70px" circle />
      <div>
        <SkeletonBlock width="30%" height="18px" style={{ marginBottom: 8 }} />
        <SkeletonBlock width="20%" height="14px" />
      </div>
    </BioHeader>

    <SkeletonBlock width="100%" height="60px" />

    {/* Basic information */}
    <BasicInfo>
      <SkeletonBlock width="45%" height="14px" />
      <SkeletonBlock width="45%" height="14px" />
      <SkeletonBlock width="45%" height="14px" />
      <SkeletonBlock width="45%" height="14px" />
    </BasicInfo>

    {/* Actions */}
    <ActionRow>
      <SkeletonBlock width="120px" height="40px" />
      <SkeletonBlock width="120px" height="40px" />
    </ActionRow>

    {/* Tabs */}
    <TabsHeader>
      <SkeletonBlock width="20%" height="16px" />
      <SkeletonBlock width="20%" height="16px" />
      <SkeletonBlock width="20%" height="16px" />
    </TabsHeader>

    <TabsContent>
      <SkeletonBlock width="100%" height="120px" />
    </TabsContent>
  </SkeletonContainer>
);

export default LocumProfileSkeleton;

// Styled containers

const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${({ theme }) => theme.palette.white};
  border-radius: 8px;

  @media (max-width: 540px) {
    border-radius: 0;
    padding: 8px;
  }
`;

const BioHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const BasicInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 12px;
`;

const TabsHeader = styled.div`
  display: flex;
  gap: 16px;
`;

const TabsContent = styled.div`
  /* matches the ExperienceSection height roughly */
`;
